import { createAsyncThunk } from "@reduxjs/toolkit";
import ApiService from "../../utils/apiService";

export const fetchVrImages = createAsyncThunk("vrImages/fetchAll", async () => {
  return await ApiService.get("/vr-images", false);
});

export const fetchVrImageById = createAsyncThunk("vrImages/fetchById", async (id) => {
  return await ApiService.getById("/vrImageGetById", id);
});
